<template>
  <v-app-bar
    app
    dense
    color="tertiary"
    elevation="0"
    class="inverted-corners"
    style="z-index: 999"
  >
    <v-menu
      v-model="menu"
      offset-y
      class="overflow-y-hidden"
      :nudge-width="300"
      max-width="250"
      :close-on-content-click="false"
      v-if="isAdmin"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-row>
          <v-col cols="8" md="4">
            <v-list-item
              class="px-2 rounded-lg"
              dense
              link
              v-bind="attrs"
              v-on="{ ...on, click: openMenu }"
              v-if="!hasStoreInfo"
            >
              <v-img
                :alt="`${storeInfo.nome_loja}`"
                :src="storeInfo.tema_logotipo"
                max-height="32"
                max-width="32"
                class="rounded-xl mr-2"
                v-if="storeInfo.tema_logotipo"
              ></v-img>
              <v-icon size="24" dark v-else>mdi-account-tie</v-icon>
              <v-list-item-title
                v-if="smAndUp"
                class="text-start text-subtitle-2 white--text font-bold ml-sm-1"
              >
                {{
                  storeInfo.nome_loja
                    ? storeInfo.nome_loja
                    : "Selecionar produtor"
                }}
              </v-list-item-title>
            </v-list-item>
          </v-col>
        </v-row>
      </template>

      <v-card max-height="400px" class="overflow-y-auto" tile>
        <v-toolbar v-if="!hasStoreInfo" flat class="research-intern-field">
          <v-text-field
            placeholder="Buscar produtor"
            append-icon="mdi-account-tie"
            class="py-0"
            hide-details
            v-model="research"
            autofocus
          ></v-text-field>
        </v-toolbar>
        <v-card-text class="py-0 px-2">
          <template v-if="storeLoading">
            <v-skeleton-loader
              type="list-item-avatar"
              class="my-1"
              v-for="n in 5"
              :key="n"
            ></v-skeleton-loader>
          </template>
          <template v-else>
            <v-list-item
              v-for="store in storeListFiltered"
              :key="store.idloja"
              @click="[setProductor(store), goToDashboard()]"
              dense
              class="px-0"
            >
              <v-img
                :alt="`${store.nome_loja}`"
                :src="store.tema_logotipo"
                height="25"
                width="25"
                class="rounded-xl mr-4"
              ></v-img>
              <v-list-item-title>{{ store.nome_loja }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-menu>

    <v-row justify="end" align="center" class="mr-sm-6 ml-n16">
      <v-btn
        outlined
        dark
        class="rounded-xxl mr-3 bar-button"
        height="32"
        width="90"
        @click="goToCash()"
        ><v-icon small class="pr-2">mdi-food</v-icon> Bar</v-btn
      >
      <AppUserMenu />
      <v-app-bar-nav-icon
        v-if="!lgAndUp"
        class="ml-2"
        color="white"
        width="32"
        height="32"
        @click.stop="toggleDrawer(true)"
      ></v-app-bar-nav-icon>
    </v-row>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import AppUserMenu from "@/layouts/components/AppUserMenu.vue";
import _ from "lodash";
import displayHelpers from "@/mixins/breakpoints.mixins";
export default {
  name: "AppBar",
  mixins: [displayHelpers],
  components: {
    AppUserMenu,
  },
  data() {
    return {
      menu: true,
      research: "",
    };
  },
  computed: {
    ...mapGetters([
      "storeSelector",
      "storeList",
      "storeLoading",
      "storeInfo",
      "isAdmin",
    ]),
    storeListFiltered() {
      return this.storeList.filter(store =>
        store.nome_loja
          .toString()
          .toLocaleLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(
            this.research
              .toString()
              .toLocaleLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          )
      );
    },
    hasStoreInfo() {
      return _.isEmpty(this.storeInfo);
    },
  },
  methods: {
    ...mapActions(["setStoreSelector", "setStore"]),
    ...mapMutations(["toggleDrawer"]),
    openMenu() {
      this.menu = !this.menu;
      this.setStoreSelector();
    },
    goToCash() {
      window.open("https://eleven.cash/admin/login", "_blank");
    },
    setProductor(store) {
      this.setStore(store);
      this.research = "";
      this.menu = false;
    },
    goToDashboard() {
      if (this.$route.path !== "/dashboard-produtor") {
        this.$router.push("/dashboard-produtor");
      }
    },
    searchEvents(item, queryText, itemText) {
      const normalizedQuery = this.replaceSpecialChars(
        queryText
          .toString()
          .toLocaleLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
      );
      const normalizedItem = this.replaceSpecialChars(
        itemText
          .toString()
          .toLocaleLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
      );

      return normalizedItem.includes(normalizedQuery);
    },
  },
  beforeMount() {
    this.setProductor(this.storeInfo);
  },
};
</script>

<style lang="scss">
.bar-button {
  border: 2px solid currentColor;
}

.inverted-corners {
  position: relative;
}
.inverted-corners:before {
  content: "";
  position: absolute;
  height: 40px;
  width: 40px;
  left: 0;
  top: 48px;
  border-top-left-radius: 50%;
  box-shadow: 0 -20px 0 0 var(--v-tertiary-base);
}
.inverted-corners:after {
  content: "";
  position: absolute;
  height: 40px;
  width: 40px;
  right: 0;
  top: 48px;
  border-top-right-radius: 50%;
  box-shadow: 0 -20px 0 0 var(--v-tertiary-base);
  z-index: -1;
}
.research-intern-field {
  position: sticky !important;
  top: 0 !important;
  z-index: 999 !important;
}
</style>
